/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const reportsDoughnutChartData = {
  labels: ["Living Room", "Kitchen", "Attic", "Garage", "Basement"],
  datasets: {
    label: "Consumption",
    backgroundColors: ["primary", "secondary", "info", "success", "warning"],
    data: [15, 20, 13, 32, 20],
  },
};

export default reportsDoughnutChartData;
